import "./spinner.css";

type SProps = {
  big?: boolean;
};

export default function Spinner({ big }: SProps) {
  return (
    <div className="w-full flex justify-center">
      <div className={big ? "loading-spinner-big": "loading-spinner"}></div>
    </div>
  );
}
